'use client'
import { withLayout } from '../../shared/Styles.js'
import * as TabsPrimitive from '../../components/tabs.js'
import { cn, isLexicalEmpty } from '../../helpers/index.js'
import type { TabsProps } from './types.js'
import React from 'react'
import ShelfDisplay from '../ShelfDisplay/index.js'
import AccordionCards from '../AccordionCards/index.js'
import Faq from '../Faq/index.js'
import MultiLayoutGraphicBlock from '../MultiLayoutGraphicBlock/MultiLayoutGraphicBlock.js'
import Title from '../Title/index.js'
import Graphic from '../Graphic/index.js'
import WhyChoose from '../WhyChoose/index.js'
import BrandEquity from '../BrandEquity/index.js'
import BrandCardLink from '../BrandCardLink/index.js'

const Tabs = React.forwardRef<HTMLDivElement, TabsProps>(({ data, className }, forwardedRef) => {
  const { theme, shape, align, tabs = [], sectionTitle } = data

  const renderTabContent = (tabContent: TabsProps['data']['tabs'][number]['tabContent'][number]) => {
    if (tabContent?.blockType === 'ipc-shelfdisplay') {
      return <ShelfDisplay data={tabContent} />
    } else if (tabContent?.blockType === 'ipc-multiLayoutGraphicBlock') {
      return <MultiLayoutGraphicBlock data={tabContent} />
    } else if (tabContent?.blockType === 'ipc-accordioncards') {
      return <AccordionCards data={tabContent} />
    } else if (tabContent?.blockType === 'ipc-faq') {
      return <Faq data={tabContent} />
    } else if (tabContent?.blockType === 'ipc-graphic') {
      return <Graphic data={tabContent} />
    } else if (tabContent?.blockType === 'ipc-whychoose') {
      return <WhyChoose data={tabContent} />
    } else if (tabContent?.blockType === 'ipc-brand-equity') {
      return <BrandEquity data={tabContent} />
    } else if (tabContent?.blockType === 'ipc-brand-card-link') {
      return <BrandCardLink data={tabContent} />
    } else {
      return null
    }
  }

  return (
    <section ref={forwardedRef} className={cn(theme === 'dark' ? 'aiui-dark' : '', className)}>
      {sectionTitle && <Title className="section-title" data={{ title: sectionTitle }} />}
      <TabsPrimitive.Tabs shape={shape} align={align} defaultValue={tabs?.[0]?.id || tabs?.[0]?.tabName}>
        {/* <TabsPrimitive.TabsList className="tabs-list">
          {(Array.isArray(tabs) ? tabs : [])?.map(tab => (
            <TabsPrimitive.TabsTrigger
              key={tab.id || tab.tabName}
              value={tab.id || tab.tabName}
              className="tabs-trigger"
            >
              {tab.tabName}
            </TabsPrimitive.TabsTrigger>
          ))}
        </TabsPrimitive.TabsList> */}
        {/* Tab为1时，不展示tab按钮 */}
        {Array.isArray(tabs) && tabs.length > 1 && (
          <TabsPrimitive.TabsList className="tabs-list">
            {tabs.map(tab => (
              <TabsPrimitive.TabsTrigger
                key={tab.id || tab.tabName}
                value={tab.id || tab.tabName}
                className="tabs-trigger"
              >
                {tab.tabName}
              </TabsPrimitive.TabsTrigger>
            ))}
          </TabsPrimitive.TabsList>
        )}
        {(Array.isArray(tabs) ? tabs : [])?.map((tab: any) => (
          <TabsPrimitive.TabsContent
            key={tab.id || tab.tabName}
            value={tab.id || tab.tabName}
            className={`tabs-content ${tabs?.length > 1 ? 'mt-[24px]' : ''}`}
          >
            {tab.caption || !isLexicalEmpty(tab?.subtitle) ? (
              <Title className="tabs-title" data={{ caption: tab?.caption, subtitle: tab?.subtitle }} />
            ) : null}
            {tab.tabContent?.[0] ? renderTabContent(tab.tabContent?.[0]) : null}
          </TabsPrimitive.TabsContent>
        ))}
      </TabsPrimitive.Tabs>
    </section>
  )
})
Tabs.displayName = 'Tabs'
export default withLayout(Tabs)
